/**
 * Created by Miguel on 23/05/2017
 */
import { Component, HostListener,OnInit, ViewChild,ChangeDetectionStrategy, ViewEncapsulation  } from '@angular/core';
import { ActivatedRoute,RouterLink} from '@angular/router';
import { DomSanitizer,  SafeResourceUrl , SafeHtml } from '@angular/platform-browser';
import { Subscription } from 'rxjs/Subscription';
import { EventBean } from '../../beansts/Event';
import { CompanyService }  from '../../services/company.service';
import { AppDataService }  from '../../services/app-data.service';
import {CompanyBean} from "../../beansts/company.bean";
import {ItemBean} from "../../beansts/item.bean";

import { MessagingService } from "../../messaging.service";
import {Router} from "@angular/router";
import {FormBuilder, FormGroup} from "@angular/forms";
import {TranslationService} from '../../services/translation.service';
import {EventComponent} from './event.component'
import { WalletService }  from '../../services/wallet.services';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
//teleview
declare var Swal : any;
declare var $ : any;
@Component({
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.Emulated,
    selector : 'eventdashboard',
    templateUrl:'event.dashboard.component.html',
    providers  : []
})
export class EventDashboardComponent extends EventComponent implements OnInit {

    private _companiesSubscription : Subscription;
    public event: EventBean=new EventBean();
    public buyerGold=0

    public photo='https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/gameImages%2Fbackgrounds%2Ftela%20fundo%20reuniao.jpeg?alt=media&token=2303f2d4-4b37-4531-aca0-c26b489a5465'
    public muted;

    public endDate=''
    public startDate=''
    public queryRoom=null;
    public currentActivities=[]
    public nextActivities=[]
    public oldActivities=[]

    public hasCurrentActivities=false;
    public hasNextActivities=false;
    public hasOldActivities=false;

    public user={uid:'n/a',full_name:'Anonimo',profile_picture:'nil'};





    constructor( public _sanitizer: DomSanitizer,public translate: TranslationService, public _router : Router,public _routeParams : ActivatedRoute,public _companyService : CompanyService,public _walletService : WalletService, public _appData : AppDataService,public msgService: MessagingService, public fb: FormBuilder) {
      super( _sanitizer, translate, _router,_routeParams, _companyService,_walletService,  _appData,msgService,null)
    }
    public ngOnDestroy() {

    }

    @HostListener('document:keydown', ['$event'])
    keypress(e: KeyboardEvent) {
      if (e.keyCode == 38) {
        this.zoom(true)
        // up arrow
      }
      else if (e.keyCode == 40) {
          // down arrow
          this.zoom(false)
      }

    }
    public getLink(){
      let domain=window.location.origin
      navigator.clipboard.writeText(domain+"/eventdashboard/"+this._appData.event.id+"?evt="+this.appEvent);
      Swal.fire(this.translate.instant('SUCCESS'),'Link do evento transferido para memória. Use Ctrl-V para colar o link em conversa com quem você quiser convidar.')
    }
    public onChangeForm(){
      
    }
    public longToDate(number){
      let date=new Date(number)
      let day=date.getDate();
      let month=date.getMonth()+1;
      let monthStr=month.toString();
      if (monthStr.length==1) monthStr='0'+monthStr;
      let year=date.getFullYear();
      let hour=date.getHours();
      let hourStr=hour.toString();
      if (hourStr.length==1) hourStr='0'+hourStr;
      let minute=date.getMinutes()
      let minuteStr=minute.toString();
      if (minuteStr.length==1) minuteStr='0'+minuteStr;

      return day+'/'+monthStr+'/'+year+' '+hourStr+':'+minuteStr
  }


  public gotoActivity(ac){
    let domain=window.location.origin
    window.location.href=domain+"/speakerroom/"+this._appData.event.id+'?evt='+this._appData.dashboardEvent.id+'&speaker='+ac.id;

  }

  public stringToMilis(str){
    var arrDataExclusao = str.split('/');
    var split2=arrDataExclusao[2].split(' ')
    var split3=split2[1].split(':')
    var stringFormatada = arrDataExclusao[1] + '-' + arrDataExclusao[0] + '-' + split2[0];
    let date = new Date(stringFormatada);
    date.setHours(split3[0])
    date.setMinutes(split3[1])
    return date.getTime();
}
    public ngOnInit() : any {
      super.ngOnInit();      
      this._appData.page='dashboard'
      if (this.appEvent){
        this._companyService.getEventOnApp().doc(this.appEvent).get().then(val=>{
          this._appData.dashboardEvent=val.data();

          this._appData.room=this._appData.dashboardEvent.rooms[0]
          $("#chatReload").click();

          $('#dashboardContent').css('background-color',this._appData.dashboardEvent.color)

          this.endDate=this.longToDate(this._appData.dashboardEvent.end)
          this.startDate=this.longToDate(this._appData.dashboardEvent.start)

          let date= new Date();
          let milis=date.getTime();
          this._companyService.getEventOnApp().where("father","==",this.appEvent).get().then(v=>{
            v.forEach(a=>{
              this.hasCurrentActivities=false;
              this.hasNextActivities=false;
              this.hasOldActivities=false;
              let ac=a.data()
              ac.startDate=this.longToDate(ac.start);
              if (ac.start<milis && ac.end>milis){
                this.currentActivities.push(ac)
                this.hasCurrentActivities=true;
               }
              else if (ac.start>milis){
                this.nextActivities.push(ac)
                this.hasNextActivities=true; 
              }
              else{
                this.oldActivities.push(ac)
                this.hasOldActivities=true;
  
              }
            })
            this.loadSpeakers();
            this.nextSpeeches();
            this.oldSpeeches();
          })

        })
      }
      try{
        var refreshInterval=setInterval(()=>{
          if (this._appData.room){
            if (this._appData.room.textures.meetingBackground){
              this.photo=this._appData.room.textures.meetingBackground;
            }
            else{
              this.photo='https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/gameImages%2Fbackgrounds%2Ftela%20fundo%20reuniao.jpeg?alt=media&token=2303f2d4-4b37-4531-aca0-c26b489a5465'
            }
            clearInterval(refreshInterval);
          }
        },5000)  
      }
      catch (err){}
      this._walletService.getTokenBalance('user',this._appData.instagramUser.uid).subscribe(val=>{
        let vet=val.json();
        let lid=1;
        vet.forEach(element => {
          let address=element.mint_address
          let amount=element.ui_amount
          if (address=='BmHvLKAGRd2o3WKm2U7u7qaJoAjzqCQfzLyUVrFznmuu'){
            this.buyerGold=amount;
          }
        })
      })

  }
  public gotoLove(){
    this._appData.cellScreen='userOnEvent'
    this._appData.toggleCellPhone=true
  }
  public gotoMetaverse(){
    let sent=false;
    let length=this._appData.dashboardEvent.rooms.length;
    let testes=0
    this._appData.dashboardEvent.rooms.forEach(v=>{
/*      this._companyService.getUserRefOnRoom(v.id).once("value",(snap)=>{
				let us=snap.val(); //objects correspond to users;
				let tusers=0;
        testes=testes+1;
				if (us){
					tusers=Object.keys(us).length;
				}
				else{
					tusers=0;
				}
        if (tusers<v.roomLimit){
          sent=true;
          let domain=window.location.origin
          window.location.href=domain+"/welcome?event="+this._appData.event.id+'&room='+v.id;     
        }
        if ((testes==length) && !sent){
          Swal.fire({title:'Todas as salas estão ocupadas',text:'Infelizmente todas as salas estão em seu limite de usuários. Aguarde para tentar de novo. Por enquanto aproveite a mídia do evento.'})
        }

    })*/

  })


    
  }
  public oldSpeeches(){
        var itemsMainDiv = ('.MultiCarousel');
        var itemsDiv = ('.MultiCarousel-inner');
        var itemWidth;
      
        $('.leftLst, .rightLst').click(function () {
          var condition = $(this).hasClass("leftLst");
          if (condition)
            click(0, this);
          else
            click(1, this)
        });
      
        ResCarouselSize();
      
      
      
      
        $(window).resize(function () {
          ResCarouselSize();
        });
        setTimeout(()=>{
          ResCarouselSize();

        },5000)
      
        //this function define the size of the items
        function ResCarouselSize() {
          var incno = 0;
          var dataItems = ("data-items");
          var itemClass = ('.item');
          var id = 0;
          var btnParentSb = '';
          var itemsSplit = [];
          var sampwidth = $(itemsMainDiv).width();
          var bodyWidth = $('body').width();
          $(itemsDiv).each(function () {
            id = id + 1;
            var itemNumbers = $(this).find(itemClass).length;
            btnParentSb = $(this).parent().attr(dataItems);
            itemsSplit = btnParentSb.split(',');
            $(this).parent().attr("id", "MultiCarousel" + id);
      
      
            if (bodyWidth >= 1200) {
              incno = itemsSplit[3];
              itemWidth = sampwidth / incno;
            }
            else if (bodyWidth >= 992) {
              incno = itemsSplit[2];
              itemWidth = sampwidth / incno;
            }
            else if (bodyWidth >= 768) {
              incno = itemsSplit[1];
              itemWidth = sampwidth / incno;
            }
            else {
              incno = itemsSplit[0];
              itemWidth = sampwidth / incno;
            }
            $(this).css({ 'transform': 'translateX(0px)', 'width': itemWidth * itemNumbers });
            $(this).find(itemClass).each(function () {
              $(this).outerWidth(itemWidth);
            });
      
            $(".leftLst").addClass("over");
            $(".rightLst").removeClass("over");
      
          });
        }
      
      
        //this function used to move the items
        function ResCarousel(e, el, s) {
          var leftBtn = ('.leftLst');
          var rightBtn = ('.rightLst');
          var translateXval;
          var divStyle = $(el + ' ' + itemsDiv).css('transform');
          var values = divStyle.match(/-?[\d\.]+/g);
          var xds = Math.abs(values[4]);
          let dif=itemWidth * s
          if (e == 0) {
            translateXval = parseInt(xds.toString()) - parseInt(dif.toString());
            $(el + ' ' + rightBtn).removeClass("over");
      
            if (translateXval <= itemWidth / 2) {
              translateXval = 0;
              $(el + ' ' + leftBtn).addClass("over");
            }
          }
          else if (e == 1) {
            var itemsCondition = $(el).find(itemsDiv).width() - $(el).width();
            translateXval = parseInt(xds.toString()) + parseInt(dif.toString());
            $(el + ' ' + leftBtn).removeClass("over");
      
            if (translateXval >= itemsCondition - itemWidth / 2) {
              translateXval = itemsCondition;
              $(el + ' ' + rightBtn).addClass("over");
            }
          }
          $(el + ' ' + itemsDiv).css('transform', 'translateX(' + -translateXval + 'px)');
        }
      
        //It is used to get some elements from btn
        function click(ell, ee) {
          var Parent = "#" + $(ee).parent().attr("id");
          var slide = $(Parent).attr("data-slide");
          ResCarousel(ell, Parent, slide);
        }
      
    
      
    
  }

  public nextSpeeches(){
    var itemsMainDiv = ('.ProximaCarousel');
    var itemsDiv = ('.ProximaCarousel-inner');
    var itemWidth;
    
    $('.ProximaleftLst, .ProximarightLst').click(function () {
      var condition = $(this).hasClass("ProximaleftLst");
      if (condition)
      click(0, this);
      else
      click(1, this)
    });
  
    ResCarouselSize();
  
    $(window).resize(function () {
    ResCarouselSize();
    });
    setTimeout(()=>{
      ResCarouselSize();

    },5000)

  //this function define the size of the items
  function ResCarouselSize() {
    var incno = 0;
    var dataItems = ("data-items");
    var itemClass = ('.item');
    var id = 0;
    var btnParentSb = '';
    var itemsSplit = [];
    var sampwidth = $(itemsMainDiv).width();
    var bodyWidth = $('body').width();
    var itemWidth
    $(itemsDiv).each(function () {
    id = id + 1;
    var itemNumbers = $(this).find(itemClass).length;
    btnParentSb = $(this).parent().attr(dataItems);
    itemsSplit = btnParentSb.split(',');
    $(this).parent().attr("id", "ProximaCarousel" + id);
  
  
	if (bodyWidth >= 1200) {
	  incno = itemsSplit[3];
	  itemWidth = sampwidth / incno;
	} else if (bodyWidth >= 992) {
	  incno = itemsSplit[2];
	  itemWidth = sampwidth / incno;
	} else if (bodyWidth >= 768) {
	  incno = itemsSplit[1];
	  itemWidth = sampwidth / incno;
	} else {
	  incno = itemsSplit[0];
	  itemWidth = sampwidth / incno;
	}
	$(this).find(itemClass).each(function () {
	  $(this).outerWidth(itemWidth);
	});
  
	$(".ProximaleftLst").addClass("over");
	$(".ProximarightLst").removeClass("over");
  
  });
  }
  
  
  //this function used to move the items
  function ResCarousel(e, el, s) {
    var leftBtn = ('.ProximaleftLst');
    var rightBtn = ('.ProximarightLst');
    var translateXval;
    var divStyle = $(el + ' ' + itemsDiv).css('transform');
    var values = divStyle.match(/-?[\d\.]+/g);
    var xds = Math.abs(values[4]);
    var dif=itemWidth * s
    if (e == 0) {
      translateXval = parseInt(xds.toString()) - parseInt(dif.toString());
      $(el + ' ' + rightBtn).removeClass("over");
      
        if (translateXval <= itemWidth / 2) {
          translateXval = 0;
          $(el + ' ' + leftBtn).addClass("over");
        }
    }
    else if (e == 1) {
      var itemsCondition = $(el).find(itemsDiv).width() - $(el).width();
      translateXval = parseInt(xds.toString()) + parseInt(dif.toString());
      $(el + ' ' + leftBtn).removeClass("over");
      
      if (translateXval >= itemsCondition - itemWidth / 2) {
        translateXval = itemsCondition;
        $(el + ' ' + rightBtn).addClass("over");
      }
    }
    $(el + ' ' + itemsDiv).css('transform', 'translateX(' + -translateXval + 'px)');
  }
  
      //It is used to get some elements from btn
      function click(ell, ee) {
      var Parent = "#" + $(ee).parent().attr("id");
      var slide = $(Parent).attr("data-slide");
      ResCarousel(ell, Parent, slide);
      }
  

  }
  public loadSpeakers(){
      var itemsMainDiv = ('.PalestraCarousel');
      var itemsDiv = ('.PalestraCarousel-inner');
      var itemWidth = "";
      
      $('.PalestraleftLst, .PalestrarightLst').click(function () {
      var condition = $(this).hasClass("PalestraleftLst");
      if (condition)
      click(0, this);
      else
      click(1, this)
      });
      
      ResCarouselSize();
      
      
      $(window).resize(function () {
      ResCarouselSize();
      });
      setTimeout(()=>{
        ResCarouselSize();

      },5000)

      //this function define the size of the items
      function ResCarouselSize() {
      var incno = 0;
      var dataItems = ("data-items");
      var itemClass = ('.item');
      var id = 0;
      var btnParentSb = '';
      var itemsSplit
      var sampwidth = $(itemsMainDiv).width();
      var bodyWidth = $('body').width();
      $(itemsDiv).each(function () {
      id = id + 1;
      var itemNumbers = $(this).find(itemClass).length;
      btnParentSb = $(this).parent().attr(dataItems);
      itemsSplit = btnParentSb.split(',');
      $(this).parent().attr("id", "PalestraCarousel" + id);
      var itemWidth;
      
      if (bodyWidth >= 1200) {
        incno = itemsSplit[3];
        itemWidth = sampwidth / incno;
      } else if (bodyWidth >= 992) {
        incno = itemsSplit[2];
        itemWidth = sampwidth / incno;
      } else if (bodyWidth >= 768) {
        incno = itemsSplit[1];
        itemWidth = sampwidth / incno;
      } else {
        incno = itemsSplit[0];
        itemWidth = sampwidth / incno;
      }
      $(this).css({
        'transform': 'translateX(0px)',
        'width': itemWidth * itemNumbers
      });
      $(this).find(itemClass).each(function () {
        $(this).outerWidth(itemWidth);
      });
      
      $(".PalestraleftLst").addClass("over");
      $(".PalestrarightLst").removeClass("over");
      
      });
      }
      
      
      //this function used to move the items
      function ResCarousel(e, el, s) {
      var leftBtn = ('.PalestraleftLst');
      var rightBtn = ('.PalestrarightLst');
      var translateXval
      var divStyle = $(el + ' ' + itemsDiv).css('transform');
      var values = divStyle.match(/-?[\d\.]+/g);
      var xds:string = Math.abs(values[4]).toString();
      var  itemWidth=0
      let dif=itemWidth * s

      if (e == 0) {
      translateXval = parseInt(xds) - parseInt(dif.toString());
      $(el + ' ' + rightBtn).removeClass("over");
      
      if (translateXval <= itemWidth / 2) {
        translateXval = 0;
        $(el + ' ' + leftBtn).addClass("over");
      }
      } else if (e == 1) {
      var itemsCondition = $(el).find(itemsDiv).width() - $(el).width();
      translateXval = parseInt(xds) + parseInt(dif.toString());
      $(el + ' ' + leftBtn).removeClass("over");
      
      if (translateXval >= itemsCondition - itemWidth / 2) {
        translateXval = itemsCondition;
        $(el + ' ' + rightBtn).addClass("over");
      }
      }
      $(el + ' ' + itemsDiv).css('transform', 'translateX(' + -translateXval + 'px)');
      }
      
      //It is used to get some elements from btn
      function click(ell, ee) {
      var Parent = "#" + $(ee).parent().attr("id");
      var slide = $(Parent).attr("data-slide");
      ResCarousel(ell, Parent, slide);
      }
      
    
  }

  public addToCalendar(activity){
    this._companyService.getCalendar(this._appData.instagramUser.uid).doc(activity.id).set(activity);
    Swal.fire({title:'Atividade adicionada',text:'Atividade adicionada com sucesso na sua agenda. Veja no seu celular'})
    this._appData.cellScreen="calendar"
    this._appData.toggleCellPhone=true
  }

    public notifyRegister(){
      let date=new Date();
      let time=date.getTime();
      let name=this._appData.instagramUser.full_name;
      let notification={
        event:this._appData.event.id,
        time:time,
        senderUid:this._appData.instagramUser.uid,
        senderName:name,
        senderThumbnail:'',
        subject:'Pedido de cadastro',
        message:'Você deseja se cadastar?',
        kind:'registerNotification',
        link:'',
        read:false,
        action:'',
        answer:''
      }
      this._companyService.addRoomNotification(this._appData.room,notification) 
    }
    public notifyAvatar(){
      let date=new Date();
      let time=date.getTime();
      let name=this._appData.instagramUser.full_name;
      let notification={
        event:this._appData.event.id,
        time:time,
        senderUid:this._appData.instagramUser.uid,
        senderName:name,
        senderThumbnail:'',
        subject:'Mudar Avatar',
        message:'Você deseja mudar seu avatar?',
        kind:'avatarChange',
        link:'',
        read:false,
        action:'',
        answer:''
      }
      this._companyService.addRoomNotification(this._appData.room,notification)   
    }
    public cameraFix(){
      let date=new Date();
      let time=date.getTime();
      let name=this._appData.instagramUser.full_name;
      let notification={
        event:this._appData.event.id,
        time:time,
        senderUid:this._appData.instagramUser.uid,
        senderName:name,
        senderThumbnail:'',
        subject:'Pedido de fix camera',
        message:'Pede para voce autorizar mudar a camera',
        kind:'cameraFix',
        link:'',
        read:false,
        action:'',
        answer:''
      }
      this._companyService.addRoomNotification(this._appData.room,notification) 
    }

    public checkKey(needKey){
      if (needKey==this._appData.instagramUser.uid){
        return true;
      }
      else{
        let filtered=this._appData.userEventContainer.filter(val=>{
          return val.name==needKey                 
        })
        if (filtered[0]){
          return true;
        } 
      }
      return false;
    }
    private checkCookie(){
      var cookieEnabled = navigator.cookieEnabled;
      if (!cookieEnabled){ 
          document.cookie = "testcookie";
          cookieEnabled = document.cookie.indexOf("testcookie")!=-1;
      }
      return cookieEnabled || this.showCookieFail();
    }
  
    public toggleLoginTab(tab){
      if (!this._appData.instagramUser){
        this.loginTab=tab;
      }
    }
    private showCookieFail(){
    // do something here
    Swal.fire('Browser sem cookies','Precisamos que você habilite os cookies para podermos fazer o cadastro na lista')
    return false;
    }


    public gotoCell(){
      if (isNaN(this._appData.instagramUser.uid)){
        this._appData.toggleCellPhone=!this._appData.toggleCellPhone;
      }
      else{
        $('#registerSocialModal').modal("show"); 
      }

    }


public enter(){
  if (!this._appData.instagramUser){
    if (this.event.private){
      $('#registerSocialModal').modal("show"); 
    }
    else{
      $('#privatePartyModal').modal("show"); 
    }
  }
}

public getImageNoDraw(imgRef) {
  if (this._appData.images[imgRef])
      return this._appData.images[imgRef];
  else {
      // Load image if not in cache
      var img = new Image();
      img.src = imgRef;
      img.onload = ()=>{
        this._appData.images[imgRef].loaded=true;
      }
      this._appData.images[imgRef] = img;
      return img;
  }
}


    public gotoMyData(){
      $('#jitsi-control-tutorial').click();

      $('#updateMeModal').modal('hide');
      this._router.navigate(['/userprofile'])
      this._companyService.getUserContainer(true)
    }


  public gotoBag(){
   // if (isNaN(this._appData.instagramUser.uid)){
      this._appData.object=null;
      $('#jitsi-control-tutorial').click();
      $('#containerModal').modal('show')
      $('#containerModal').draggable({
        handle: ".modal-header"
      });
      $('#containerModalClick').click(); 
  //  }
//    else{
   //   Swal.fire('Você está deslogado','Você precisa estar logado para acessar sua mochila.')
 //   }
  }
 










}





// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/event.dashboard.component.ts